import { useState, useCallback, useEffect, useMemo } from 'react'
import './App.css'
import Library from './pages/Library'
import SetlistsSection from './pages/SetlistsSection'
import PresentSection from './pages/PresentSection'
import Taskbar from './components/Taskbar'

const TABS = [
  { id: 'library', label: 'Library' },
]

function App() {
  const [activeTab, setActiveTab] = useState('setlists')
  const [tabLabel, setTabLabel] = useState('Setlists')
  const [taskbarActions, setTaskbarActions] = useState([])
  const [presentSetlist, setPresentSetlist] = useState(null)

  const tabs = useMemo(() => [
    ...TABS,
    { id: 'setlists', label: activeTab === 'setlists' && tabLabel.includes(' - ') ? 'Setlist' : 'Setlists', sublabel: activeTab === 'setlists' && tabLabel.includes(' - ') ? tabLabel.slice(tabLabel.indexOf(' - ') + 3) : null },
    ...(presentSetlist ? [{ id: 'present', label: 'Present', sublabel: activeTab === 'present' ? (presentSetlist.title || '') : null }] : [])
  ], [activeTab, tabLabel, presentSetlist])

  useEffect(() => {
    const activeTabObj = tabs.find(t => t.id === activeTab)
    document.title = `Lyri | ${activeTabObj?.label || ''}`
  }, [activeTab, tabs])

  const loadPresent = useCallback((setlist) => {
    setPresentSetlist(setlist)
    setActiveTab('present')
    setTaskbarActions([])
    setTabLabel(setlist.title || 'Present')
  }, [])

  function handleTabChange(tab) {
    setActiveTab(tab)
    setTaskbarActions([])
    if (tab === 'setlists') setTabLabel('Setlists')
    if (tab === 'present') setTabLabel(presentSetlist?.title || 'Present')
  }

  return (
    <div className="App">
      <header className="App-header">
        {activeTab === 'library' && <Library onActionsChange={setTaskbarActions} />}
        {activeTab === 'setlists' && (
          <SetlistsSection
            onLabelChange={setTabLabel}
            onActionsChange={setTaskbarActions}
            onPresent={loadPresent}
          />
        )}
        {activeTab === 'present' && presentSetlist && (
          <PresentSection
            setlist={presentSetlist}
            onLabelChange={setTabLabel}
            onActionsChange={setTaskbarActions}
          />
        )}
      </header>
      <Taskbar
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        actions={taskbarActions}
      />
    </div>
  )
}

export default App
